<template>
  <base-modal ref="modal" @hiding="reset()" :overflowAuto="false">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin tw-mb-5">Update Prescriber</h3>

      <div v-if="isLoading" class="tw-flex tw-justify-center tw-my-6">
        <base-spinner :size="24" label="Loading users..." />
      </div>
      <div v-else>
        <base-advanced-select
          label="Select prescriber"
          :options="filteredLocations"
          v-model="selectedLocation"
          placeholder="Select prescriber"
          label-key="text"
          value-key="value"
        />
      </div>

      <inline-error id="assign-prescription-error" class="tw-my-3" :title="errorTitle" :message="errorMessage" :error="error" />

      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="saveAssignment" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!selectedLocation">
          Assign
        </base-button>

        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import BaseSpinner from "@/components/base/BaseSpinner";
export default {
  name: "AssignPrescriptionModal",
  components: { InlineError, BaseSpinner },
  props: {
    businessId: String,
    businessPrescriberLocations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      selectedLocation: null,
      prescriptionId: null,
      businessLocationId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
      filteredLocations: [],
    };
  },
  methods: {
    show(prescription) {
      this.prescriptionId = prescription.id;
      this.businessLocationId = prescription.businessLocationId;
      this.selectedLocation = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.isLoading = true;

      try {
        // Use businessPrescriberLocations from prop (filtered and sorted)
        this.locations = (this.businessPrescriberLocations || [])
          .filter((loc) => loc.name && typeof loc.name === "string" && loc.name.trim())
          .sort((a, b) => a.name.localeCompare(b.name));

        // this.filterLocations();
        this.$nextTick(() => {
          this.filterLocations(); // Populate filteredLocations for select

          // Auto-select supervising prescriber location if present
          if (prescription.supervisingPrescriberId) {
            const selected = this.filteredLocations.find((loc) => loc.value === prescription.supervisingPrescriberId);
            if (selected) {
              this.selectedLocation = selected;
            }
          }

          this.$refs.modal.show();
        });
      } catch (err) {
        this.errorTitle = "Error loading locations";
        this.errorMessage = "Could not load prescriber locations.";
        this.error = err;
        this.filteredLocations = [];
      } finally {
        this.isLoading = false;
      }
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.selectedLocation = null;
      this.filteredLocations = [];
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.isLoading = false;
    },
    filterLocations() {
      this.filteredLocations = this.locations.map((loc) => ({
        businessLocationId: loc.businessLocationId,
        businessId: loc.businessId,
        name: loc.name,
        line1: loc.line1,
        line2: loc.line2,
        city: loc.city,
        state: loc.state,
        zip: loc.zip,
        phoneNumber: loc.phoneNumber,
        emailAddress: loc.emailAddress,
        text: loc.name,
        value: loc.businessLocationId,
      }));
    },
    async saveAssignment() {
      if (!this.selectedLocation) return;
      this.isLoading = true;
      try {
        await this.$axios.put(`/businesses/${this.businessId}/prescriptions/${this.prescriptionId}/assign`, {
          supervisingPrescriberId: this.selectedLocation.businessLocationId,
        });
        this.$emit("update-supervising-prescriber", this.selectedLocation.businessLocationId);

        this.EventBus.$emit("member_update");
        this.EventBus.$emit("GLOBAL_NOTIFY", {
          title: "Supervising prescriber assigned ",
          message: `The supervising prescriber was assigned`,
        });
        this.hide();
      } catch (err) {
        this.errorTitle = "Error assigning supervising prescriber";
        this.errorMessage = "We encountered an error. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
